<template>
  <div class="check_list">
    <div class="label_title">
      付款資訊
    </div>
    <div class="info_area">
      <div class="info_top_space"/>
      <div class="title">訂單待付款</div>
      <div style="height: 18px;"/>
      <div class="subtitle">請將結帳金額轉至以下帳號</div>
      <div style="height: 18px;"/>
      <div class="order_person">
        <div class="order_num">訂單編號:{{ orderNum }}
          <a class="copy" target="_blank" title="copy" @click="clickCopy">
            <img class="copy" src="/img/image/icon/copy.png" loading="lazy" alt="copy"/>
          </a>
        </div>
        <div style="height: 10px;"/>
        <div class="order_info">訂購人:{{ name }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">連絡電話:{{ phone }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">電子信箱:{{ email }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">收件地址:{{ address }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">備註:{{ note }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">帳號末五碼:{{ state }}</div>

        <div style="height: 32px;"/>
        <div class="row no-gutters">
          <div class="col text_style">商品</div>
          <div class="row no-gutters amount_area">
            <div class="col-auto text_style">數量</div>
            <div class="col-auto text_style">小計</div>
          </div>
        </div>
        <div style="height: 8px;"/>
        <div class="divider"/>
        <div style="height: 8px;"/>
        <div v-for="(item,index) in commodityList" :key="index">
          <OrderCommodity :index="index" :item="item"/>
        </div>
        <div style="height: 8px;"/>
        <div class="divider"/>
        <div style="height: 8px;"/>
        <div class="subtotal">
          <div class="row">
            <div class="col subtotal_label">小計</div>
            <div class="price">NT$ {{ price }}</div>
          </div>
          <div style="height: 14px"/>
          <div class="row">
            <div class="col subtotal_label">低溫宅配</div>
            <div class="price">NT$ {{ feeText }}</div>
          </div>
          <div style="height: 14px"/>
          <div class="row">
            <div class="col subtotal_label">付款金額總計</div>
            <div class="total_price">NT$ {{ totalPriceText }}</div>
          </div>

        </div>
        <div class="subtotal_space"/>
      </div>
      <div class="payment_info">
        <div class="title">付款資訊</div>
        <div style="height: 32px"/>
        <table>
          <tbody>
          <tr>
            <th scope="row">付款金額</th>
            <td class="total_price">${{ totalPrice }}</td>
          </tr>
          <tr>
            <th scope="row">銀行名稱</th>
            <td class="text">{{ bankName }}</td>
          </tr>
          <tr>
            <th scope="row">銀行代碼</th>
            <td class="text">{{ bankNumber }}</td>
          </tr>
          <tr>
            <th scope="row">帳戶名稱</th>
            <td class="text">{{ accountName }}</td>
          </tr>
          <tr>
            <th scope="row">銀行帳號</th>
            <td class="text">{{ accountNumber }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="height: 36px"/>
      <div class="user_bank_account row no-gutters align-items-baseline">
        <div class="text_label">請輸入匯款帳號末五碼以完成結帳<span class="must">*</span></div>
        <input class="input_style" v-model="bankAccountSuffix" placeholder="請輸入匯款帳號末五碼" @input="limitInput"/>
        <div v-if="isNotEmpty(errors.bankAccount)" class="error-message">{{ errors.bankAccount }}</div>
      </div>
      <div style="height: 36px"/>
      <div class="notice_area">
        <div class="title">注意事項</div>
        <div style="height: 4px"/>
        <div class="info">1.訂單資訊已寄信至訂購人電子信箱。</div>
        <div style="height: 4px"/>
        <div class="info">2.至「查詢訂單」頁面，輸入訂單編號可以查詢訂單寄送狀態。</div>
        <div style="height: 4px"/>
        <div class="info">3.完成結帳後，訂單寄送狀態會同步寄信至訂購人電子信箱。</div>
        <div style="height: 4px"/>
        <div class="info">4.登入Line可以第一時間收到訂單寄送狀態通知</div>
        <div style="height: 4px"/>
        <div class="info">5.如有任何問題請透過以下方式聯繫客服。</div>
        <div style="height: 24px"/>
      </div>
      <div class="notice_divider">
        <div class="divider"/>
      </div>
      <div style="height: 42px"/>
      <div class="down_area">
        <div class="row align-items-center justify-content-between no-gutters">
          <div class="row">
            <button type="button" class="btn btn_icon_style" @click="clickBtn('instagram')">
              <img src="/img/image/icon/ig.png" class="icon" loading="lazy"/>
            </button>
            <div class="icon_space"/>
            <button type="button" class="btn btn_icon_style" @click="clickBtn('line')">
              <img src="/img/image/icon/line.png" class="icon" loading="lazy"/>
            </button>
          </div>
          <button type="button" class="btn btn_style btn-primary"
                  @click="clickPayment">
            <span class="btn_text">完成結帳</span>
          </button>
        </div>
      </div>
      <div style="height: 12px"/>
      <div class="hint">付款後,訂單狀態如未立即變更,請待10分鐘後再查詢</div>
      <div style="height: 12px"/>
    </div>
  </div>
</template>

<script>

import OrderCommodity from "../../components/OrderCommodity";
import {checkError, copyText, getPrice, isEmpty} from "../../util/helpers";
import {validateEmail, validatePhoneNumber} from "../../util/rules";
import CustomDialog from "./CustomDialog";
import Vue from "vue";
import {createOrder, getCompleteOrder, getOrderDetail} from "../../api/api";
import Clipboard from "clipboard";
import AlertDialog from "../dialog/AlertDialog";

export default {
  name: "PaymentOrder",
  components: {CustomDialog, OrderCommodity},
  props: {
    order: Object,
  },
  data() {
    return {
      bankAccountSuffix: "",
      errors: {
        bankAccount: '',
      }
    };
  },
  computed: {
    orderAddress() {
      let val = this.order.OrderAddress;
      return isEmpty(val) ? null : val;
    },
    orderNum() {
      let val = this.order.trade_no;
      return isEmpty(val) ? "" : val;
    },
    name() {
      if (isEmpty(this.orderAddress)) return '';
      let val = this.orderAddress.receiver_name;
      return isEmpty(val) ? "" : val;
    },
    phone() {
      if (isEmpty(this.orderAddress)) return '';
      let val = this.orderAddress.phone_number;
      return isEmpty(val) ? "" : val;
    },
    address() {
      if (isEmpty(this.orderAddress)) return '';
      let val = this.orderAddress.address;
      return isEmpty(val) ? "" : val;
    },
    note() {
      if (isEmpty(this.orderAddress)) return '無';
      let val = this.orderAddress.note;
      return isEmpty(val) ? "無" : val;
    },
    user() {
      let val = this.order.User;
      return isEmpty(val) ? null : val;
    },
    email() {
      let val = this.user.email;
      return isEmpty(val) ? "" : val;
    },
    state() {
      return "待付款";
    },
    commodityList() {
      let val = this.order.OrderCommodities;
      return isEmpty(val) ? [] : val;
    },
    fee() {
      let val = this.order.shipping_fee;
      return isEmpty(val) ? 0 : val;
    },
    feeText() {
      return getPrice(this.fee);
    },
    price() {
      return getPrice(this.totalPrice - this.fee);
    },
    totalPrice() {
      let val = this.order.price;
      return isEmpty(val) ? 0 : val;
    },
    totalPriceText() {
      return getPrice(this.totalPrice);
    },
    settingData() {
      return this.$store.getters.getSettingData;
    },
    bankName() {
      let val = this.settingData.data.bank_name;
      return isEmpty(val) ? "" : val;
    },
    bankNumber() {
      let val = this.settingData.data.bank_code;
      return isEmpty(val) ? "" : val;
    }, accountName() {
      let val = this.settingData.data.bank_account_name;
      return isEmpty(val) ? "" : val;
    }, accountNumber() {
      let val = this.settingData.data.bank_account;
      return isEmpty(val) ? "" : val;
    },
    instagramUrl() {
      let val = this.settingData.data.url_instagram;
      return isEmpty(val) ? '' : val;
    },
    lineUrl() {
      let val = this.settingData.data.url_line;
      return isEmpty(val) ? '' : val;
    },
  },
  methods: {
    limitInput() {
      // 只允许输入数字，并限制字数为 5
      this.bankAccountSuffix = this.bankAccountSuffix.replace(/\D/g, '').slice(0, 5);
    },
    isNotEmpty(val) {
      return isEmpty(val) === false;
    },
    validateNull(type) {
      switch (type) {
        case "bankAccount":
          if (isEmpty(this.bankAccountSuffix)) {
            this.errors.bankAccount = '*您尚未填寫資料';
          } else if (this.bankAccountSuffix.length < 5) {
            this.errors.bankAccount = "*請輸入末五碼";
          } else {
            this.errors.bankAccount = '';
          }
      }
    },
    areAllErrorsEmpty() {
      return Object.values(this.errors).every(value => isEmpty(value));
    },
    async clickPayment() {
      this.validateNull('bankAccount');
      let result = this.areAllErrorsEmpty();
      if (result === false) return;
      result = await this.$dialog.show(CustomDialog);
      if (result === false) return;
      try {
        await this.$store.dispatch('showLoading');
        let response = await getCompleteOrder(this.orderNum, this.bankAccountSuffix);
        if (await checkError(this.$dialog, response)) {
          let order = response.data;
          let trade_no = response.data.trade_no;
          await this.$store.dispatch('hideLoading');
          if (this.$route.path === "/buy") {
            await this.$router.push({path: '/orderDetail', query: {trade_no: trade_no}});
          } else {
            window.location.reload();
          }
        }
      } catch (e) {
        console.log('error ', e);
      }
    },
    clickBtn(type) {
      switch (type) {
        case "line":
          window.open(this.lineUrl, '_blank');
          return;
        case "instagram":
          window.open(this.instagramUrl, '_blank');
          return;
      }
    },
    async clickCopy() {
      try {
        if (isEmpty(this.orderNum) === false) {
          let result =   await copyText(this.orderNum);
          if(result){
            await this.$dialog.show(AlertDialog, {text: "複製成功"});
          } else {
            await this.$dialog.show(AlertDialog, {text: "複製失敗"});
          }
        }
      } catch (e) {
        console.log('error clickCopy :', e);
        await this.$dialog.show(AlertDialog, {text: "複製失敗"});
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.check_list {
  width: 1120px;
  margin: 0 auto;
}

@media (max-width: 1440px) {
  .check_list {
    width: 77vw;
  }
}

@media (max-width: 1024px) {
  .check_list {
    width: 90vw;
  }
}

@media (max-width: 576px) {
  .check_list {
    width: 100vw;
  }
}


.info_top_space {
  height: 48px;
}

@media (max-width: 768px) {
  .info_top_space {
    height: 24px;
  }
}

.label_title {
  background-color: #333333;
  padding: 10px 24px 10px 24px;
  color: white;
  font-size: 20px;
  font-weight: 500;
}

.info_area {
  background-color: #FAFAFA;
}

.title {
  font-family: Noto Sans TC;
  font-size: 36px;
  font-weight: 500;
  text-align: center;
  color: black;
}

@media (max-width: 360px) {
  .title {
    font-size: 24px;
  }
}


.subtitle {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: center;
  color: #333333;
}

@media (max-width: 768px) {
  .subtitle {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .subtitle {
    font-size: 14px;
  }
}


.order_person {
  padding: 0 74px;
}


@media (max-width: 768px) {
  .order_person {
    padding: 0 50px;
  }
}

@media (max-width: 360px) {
  .order_person {
    padding: 0 16px;
  }
}


.order_num {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

.order_info {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}


.text_style {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

.amount_area {
  width: 270px;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .amount_area {
    width: 26vw;
  }
}


.divider {
  width: auto;
  height: 1px;
  background-color: #D56835;
}


.order_person > .divider {
  background-color: #CBD2E1;
}

.subtotal {
  width: 50%;
  margin: 0 0 0 auto;
  padding-right: 24px;
}

@media (max-width: 1024px) {
  .subtotal {
    width: 100%;
    margin: 0;
  }
}

.subtotal_label {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

.price {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: right;
  color: #333333;
}

.total_price {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: right;
  color: #D56835;
}

@media (max-width: 425px) {
  .total_price {
    font-size: 20px;
  }
}

.subtotal_space {
  height: 48px;
}

@media (max-width: 768px) {
  .subtotal_space {
    height: 24px;
  }
}

.payment_info {
  background-color: #FFFFFF;
  padding: 32px;
  margin-right: 74px;
  margin-left: 74px;
}


@media (max-width: 768px) {
  .payment_info {
    padding: 16px;
    margin-right: 50px;
    margin-left: 50px;
  }
}

@media (max-width: 425px) {
  .payment_info {
    padding: 8px;
    margin-right: 16px;
    margin-left: 16px;
  }
}


.payment_info .title {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}


.text_label {
  max-width: 160px;
  width: 160px;
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

.must {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

@media (max-width: 768px) {
  .must {
    font-size: 18px;
  }
}

@media (max-width: 425px) {
  .must {
    font-size: 16px;
  }
}


.input_style {
  font-family: Noto Sans TC;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  padding: 12px;
  //border-radius: 5px;
  border: 0.5px solid #DDE1E9;
  resize: none; /* 禁用用户调整大小 */
  overflow: auto; /* 确保超出内容时可以滚动 */
}

.payment_info th, .payment_info tr {
  border-top: 1px solid #CBD2E1;
  border-bottom: 1px solid #CBD2E1;
  border-left: none;
  border-right: none;
}

.payment_info table {
  width: 100%;
}

.payment_info th {
  border-right: 1px solid #CBD2E1;
  width: 25%;
  height: 52px;
  padding-left: 10px;
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #888888;
}

@media (max-width: 768px) {
  .payment_info th {
    width: 30%;
    font-size: 16px;
  }
}

@media (max-width: 567px) {
  .payment_info th {
    width: 90px;
  }
}


.payment_info td {
  width: 75%;
  padding-left: 10px;
  text-align: left;
}

@media (max-width: 768px) {
  .payment_info td {
    width: auto;
  }
}


.payment_info .text {
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 768px) {
  .payment_info .text {
    font-size: 16px;
  }
}

.user_bank_account {
  width: 100%;
  padding-left: 105px;
  padding-right: 105px;
}

@media (max-width: 768px) {
  .user_bank_account {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media (max-width: 360px) {
  .user_bank_account {
    padding-left: 40px;
    padding-right: 40px;
  }
}


.user_bank_account .text_label {
  max-width: none;
  width: auto;
}

@media (max-width: 768px) {
  .user_bank_account .text_label {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .user_bank_account .text_label {
    font-size: 16px;
  }
}


.notice_area {
  padding-left: 105px;
  padding-right: 105px;
}

@media (max-width: 768px) {
  .notice_area {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media (max-width: 425px) {
  .notice_area {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media (max-width: 360px) {
  .notice_area {
    padding-left: 16px;
    padding-right: 16px;
  }
}


.notice_area .title {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 768px) {
  .notice_area .info {
    font-size: 18px;
  }
}

@media (max-width: 425px) {
  .notice_area .title {
    font-size: 16px;
  }
}

.notice_area .info {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 425px) {
  .notice_area .info {
    font-size: 14px;
  }
}


.notice_divider {
  padding-right: 24px;
  padding-left: 24px;
}

.btn_icon_style {
  padding: 0;
  margin: 0;
  border-radius: 50%;
  width: 36px;
  height: 36px
}

.icon {
  width: 36px;
  height: 36px
}

.down_area {
  padding-left: 105px;
  padding-right: 24px;
  height: 56px;
}

@media (max-width: 768px) {
  .down_area {
    padding-left: 60px;
    padding-right: 24px;
  }
}

@media (max-width: 360px) {
  .down_area {
    padding-left: 24px;
    padding-right: 16px;
  }
}

.icon_space {
  width: 20px;
}


.hint {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: right;
  color: #D60404;
}

@media (max-width: 768px) {
  .hint {
    width: 70%;
    font-size: 18px;
    margin: 0 0 0 auto;
  }
}

@media (max-width: 360px) {
  .hint {
    width: 90%;
    font-size: 16px;
    padding: 0 10px;
  }
}

.btn_style {
  width: 230px;
  height: 56px;
  line-height: 0;
}

@media (max-width: 700px) {
  .btn_style {
    width: 200px;
    height: 48px;
  }
}

@media (max-width: 425px) {
  .btn_style {
    width: 130px;
    height: 32px;
  }
}

.btn_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: white;
}

@media (max-width: 700px) {
  .btn_text {
    line-height: 0;
    font-size: 20px;
  }
}

@media (max-width: 425px) {
  .btn_text {
    line-height: 0;
    font-size: 16px;
  }
}


.error-message {
  color: #D60404;
  font-size: 14px;
  margin-top: 8px;
  margin-left: 8px;
}

@media (max-width: 425px) {
  .error-message {
    margin-top: 4px;
    margin-left: 4px;
  }
}

.copy {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

</style>
